export default __webpack_public_path__ + "static/media/fighting.f20d1bd2.svg";